const withExt = (editor) => {
  const newEditor = editor;
  newEditor.ext = {};
  return newEditor;
};

export { withExt };
//# sourceMappingURL=with-ext.js.map
